
class common{

	constructor() {
		
        
    }
    navigation() {
        $('li.active').removeClass('active');
        $('a[href="//' + location.host + location.pathname + '"]').closest('li').addClass('active'); 
        $('a[href="//' + location.host + location.pathname + '"]').addClass('active'); 
        if (location.pathname.includes('research') || location.pathname.includes('blog-post')) {
            $('a[href="/research/"]').closest('li').addClass('active'); 
        }
        $(window).scroll(function(){
            if ($(window).scrollTop() >= 50) {
                $('nav').addClass('scrolling');
                $('nav').find('.btn-secondary').addClass('btn-sm');
            } else {
                $('nav').removeClass('scrolling');
                $('nav').find('.btn-secondary').removeClass('btn-sm');
            }
        });

    }
    portfolio(el) {
        if ($(window).width() < 768) {
            $(el).on('click', (event) => {
                $('.description.show').removeClass('show');
                event.preventDefault();
                var item = $(el).parent();
                var desc = $(item).find('.description');
                $(desc).addClass('show');
                $(desc).focus();
            });
        }
        
        
    }
	mobileNav() {
        // mobile menu slide from the right
        $('[data-toggle="slide-collapse"]').on('click', function() {
            $navMenu = $($(this).data('target'));
            $navMenu.addClass('open');
            setTimeout(() => {
                $('body').addClass('noscroll')
            }, 1000);
            setTimeout(() => {
                $('html').addClass('noscroll');
            }, 1000);
        });
        $('[data-toggle="slide-collapse-close"]').on('click', function() {
            $navMenu = $($(this).data('target'));
            $navMenu.removeClass('open');
            $('body').removeClass('noscroll');
			$('html').removeClass('noscroll');
        });
      
    }
    closeMobileMenu() {
        $('#mobileCover').on('click', function() {
            $('#mobileSlideout').removeClass('open');
        });
    }
    loadmore(el) {
        $(el).on('click', function() {
            if (!app.loading) {
                app.loading = true;
                $('.loading').removeClass('hidden');
                currentItems = $(".blog-post");
                $currentIds = [];
                currentItems.each(function(){
                    $this = $(this);
                    $currentIds.push($this.attr('id'));
                });

                featuredItem = $(".featured");
                featuredItem.each(function(){
                    $this = $(this);
                    $currentIds.push($this.attr('id'));
                });

                $posttype = $(el).data('type');
                
                $.post( "/wp-admin/admin-ajax.php", {action:'load_more', post_type: $posttype, exclude: $currentIds}, function( data ) {
                    if (data == 'false0') {
                        $(el).hide();
                        $('.button-container').append('<p>There are no more posts to show</p>');
                    } else {
                        if (parseInt(data[0]) < 6) {
                            $(el).hide();
                        }
                        $('.blog-posts-container').append(data.substring(1, data.length - 1));
                    }
                    app.loading = false;
                    $('.loading').addClass('hidden');

                });

            }
        })
    }
    
}
window.app.add('common', new common());